import { AcessoriosDTO, VehicleImage } from "../dto/CompanyDTO";
import { combustiveis, transmissao } from "../mocks/CompanyMocks";

export const getTransmissaoLabel = (id: number | null): string | null => {
  if (!id) return null;
  return transmissao.find((t) => t.id === id)?.label ?? null;
};
export const getCombustivel = (id: number | null): string | null => {
  if (!id) return null;
  return combustiveis.find((c) => c.id === id)?.label ?? null;
};

export const getTransmissaoId = (label: string | null): number | null => {
  if (!label) return null;
  return transmissao.find((t) => t.label === label)?.id ??null;
};
export const getCombustivelId = (label: string | null): number | null => {
  if (!label) return null;
  return combustiveis.find((c) => c.label === label)?.id ??null;
};

export const getSelectedAcessorios = (
  acessorios: AcessoriosDTO[]
): number[] =>
  acessorios
    .filter((a) => a.isActive)
    .map((a) => a.id);

export  const parseCurrency = (value: string | null): number => {
  if (!value) return 0;

  return Number(
    value
      .replace(/\s/g, "")
      .replace("R$", "")
      .replace(/\./g, "")
      .replace(",", ".")
  );
};

export const parseCurrencyToDecimal = (value: string | null): string => {
  if (!value) return "0";
  return value
    .replace("R$", "")
    .replace(/\./g, "")
    .trim() || "0";
};

export const resolveAssetUrl = (url: string, adId: string | number): string => {
  if (!url) return "";
  if (url.includes("veiculos")) return url;
  if (url.includes("avaliadordigital")) return url;
  if (url.includes("avaliador-ai-api")) return url;
  if (url.includes("hmlv2api")) return url;
  return `https://www.canaldorepasse.com.br/anuncios/fotos/${adId}/${url}`;
};

export const getImageSrc = (image: VehicleImage): string => {
  if (image.isNew && image.previewUrl) {
    return image.previewUrl;
  }

  if (image.url && image.adId) {
    return resolveAssetUrl(image.url, image.adId);
  }

  return "";
};

export const formatCurrency = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined) return null;

  const numberValue =
    typeof value === "string"
      ? Number(value.replace(/[^\d.-]/g, ""))
      : value;

  if (Number.isNaN(numberValue)) return null;

  return numberValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};


export const tipoAnuncio = (tipo: string): string => {
  switch (tipo) {
    case "N":
      return "Compre agora";
    case "L":
      return "Leilão";
    case "C":
      return "Cotação";
    case "P":
      return "Pacote";
    default:
      return tipo; // fallback seguro
  }
};
export const filterTipoHelper = (tipo: string): string => {
  switch (tipo) {
    case "Compre agora":
      return "N";
    case "Leilão":
      return "L";
    case "Cotação":
      return "C";
    case "Pacote":
      return "P";
    default:
      return tipo; // fallback seguro
  }
};